export const schoolModeActionTypes = {
  ENABLE_SCHOOL_MODE: 'enableSchoolMode',
  ENABLE_AI_FEATURES: 'enableAIFeatures',
};
